import fetch from 'isomorphic-fetch';
import { API2_URL, ACTIVITY_REQUEST, ACTIVITIES_SHOW, ACTIVITIES_LIST, ACTIVITY_EDIT, ACTIVITY_VERIFICATION_MEDIA, ACTIVITY_COMPLETE, ACTIVITY_CLEAR, ACTIVITY_FAIL} from "../store/config";
import { newNotification } from "./notifications";
import { history } from "../store/store";
import _ from "lodash";
import {sessionService} from "redux-react-session";
import {activityGroupShow} from "./activity_groups";
import {verificationMediaShow} from "./verification_media";
import {statusGroupList} from "./status";


/*Activities Show*/
export const activitiesShow = (page=1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(activityRequest());
				return fetch(`${API2_URL}/proigualdad/activities?include[0]=status&page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activitiesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Activities List*/
export const activitiesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(activityRequest());
				return fetch(`${API2_URL}/proigualdad/activities/groups?include[0]=activities&include[1]=modalities`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activitiesListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Goal Activities List*/
export const goalActivitiesList = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(activityRequest());
				return fetch(`${API2_URL}/proigualdad/goals/${id}/activities`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activitiesListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const fetchActivityComplete = (id = undefined) => (dispatch) => {
	dispatch(activityRequest());
	dispatch(activityClear());

	return dispatch(activityGroupShow())
		.then((groups) => {
			if(!_.isEmpty(groups.payload)){
				return dispatch(verificationMediaShow())
					.then((verification) => {
						if(!_.isEmpty(verification.payload)){
							return dispatch(statusGroupList())
								.then((status) => {
									if(!_.isEmpty(status.payload)){
										if(id){
											return dispatch(fetchActivity(id))
										}else {
											return dispatch(activityComplete());
										}
									}else {
										return dispatch(activityFail('Carga incompleta'))
									}
								})
						}else {
							return dispatch(activityFail('Carga incompleta'))
						}
					})
			}else {
				return dispatch(activityFail('Carga incompleta'))
			}
		})
}

/*Edit*/
export const fetchActivity = (id) => (dispatch) => {
	//dispatch(activityRequest());
	return dispatch(activityEdit(id))
		.then((activity) => {
			if(!_.isEmpty(activity.payload)){
				return dispatch(activityComplete());
			}else {
				return dispatch(activityFail(activity.error))
			}
		})
}

const activityEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/proigualdad/activities/${id}?include[0]=verification_media`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activityEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Activity Save*/
export const activitySave = (values) => (dispatch) => {
	dispatch(activityRequest());
	return dispatch(activityEditSave(values))
		.then((activity) => {
			if(!_.isEmpty(activity.payload)){
				return dispatch(activityMediaSave(values, activity.payload.id))
					.then((media) => {
						if(!_.isEmpty(media.payload)){
							return dispatch(activityComplete());
						}else {
							return dispatch(activityFail(media.error))
						}
					})
			}else {
				return dispatch(activityFail(activity.error))
			}
		})
};

const activityEditSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				return fetch(`${API2_URL}/proigualdad/activities${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(activityEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Activity Media Save*/
const activityMediaSave = (values, id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({verification_media_id:values.verification_media_id})
				};

				dispatch(activityRequest());
				return fetch(`${API2_URL}/proigualdad/activities/${id}/verification-media?_method=PUT`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La actividad se guardó correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/proigualdad/actividades/editar/${id}`);
							}
							return dispatch(verificationActivityEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Activity Delete */
export const activityDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'DELETE'
				};

				dispatch(activityRequest());
				return fetch(`${API2_URL}/proigualdad/activities/${id}`, options)
					.then(
						result => result.json(),
						error => error
					)
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message, type: "success"}));
							dispatch(activitiesShow())
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(activityFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*Activity Request*/
const activityRequest = () => {
	return {
		type: ACTIVITY_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

/*Activity List*/
const activitiesData = (json) => {
	return {
		type: ACTIVITIES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	};
};
/*Goal Activities List*/
const activitiesListData = (json) => {
	return {
		type: ACTIVITIES_LIST,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	};
};

/*Activity Edit*/
const activityEditData = (json) => {
	let response = {}

	if(!_.isEmpty(json.data.verification_media)){
		response = {
			id: json.data.id,
			name: json.data.name,
			amount: json.data.amount,
			group_id: json.data.group_id,
			status_id: json.data.status_id,
			verification_media_id: json.data.verification_media[0].id
		}
	}else {
		response = {
			id: json.data.id,
			name: json.data.name,
			amount: json.data.amount,
			group_id: json.data.group_id,
			status_id: json.data.status_id
		}
	}

	return {
		type: ACTIVITY_EDIT,
		isFetching: false,
		payload: response,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const verificationActivityEditData = (json) => {
	return {
		type: ACTIVITY_VERIFICATION_MEDIA,
		payload: {verification_media_id: json.data[0].id},
		timestamp: Date.now
	}
}

/*
const activityEditMediaData = (data) => {
	return {
		type: ACTIVITY_EDIT,
		isFetching: false,
		edit: data[0],
		timestamp: Date.now()
	}
};*/

const activityComplete = () => {
	return {
		type: ACTIVITY_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

/*Activity Clear*/
const activityClear = () => {
	return {
		type: ACTIVITY_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
};

/*Activity Fail*/
const activityFail = (error) => {
	return {
		type: ACTIVITY_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/activities.js